export default __webpack_public_path__ + "static/media/bottle.277b44f5.png";